<template>
    <v-row dense>
        <v-col
                cols="12"
                dense>
            <span class="subtitle-2">{{ field.title }}</span><br>
            <span class="caption">{{ field.description }}</span>
            <VueSignaturePad
                    ref="signature"
                    :class="componentClass"
                    height="200px"
                    :options="{onBegin, onEnd}" />
            <v-col
                    v-if="errorState"
                    dense
                    cols="12"
                    class="mt-2 pb-0 mb-0 pt-2">
                <v-messages
                        color="error"
                        :value="[error]" />
            </v-col>
            <v-btn
                    v-if="isFilled"
                    small
                    class="warning mt-2"
                    @click="clearSignature">
                Clear signature
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
    import Value from "../../../../../models/value.model";
    import Field from "@/models/field.model";

    export default {
        name: "FieldSignatureComponent",
        props: {
            field: {type: Object, default: () => new Field()},
        },
        data() {
            return {
                data: null,
                error: null,
            }
        },
        computed: {
            componentClass() {
                let classes = 'ma-0 mt-2 py-0 signature ';

                if (this.error) {
                    classes = classes + 'signature-error';
                }

                if (this.isFilled) {
                    classes = classes + 'signature-success';
                }

                return classes;
            },
            isFilled() {
                return !this.error && !!this.data;
            },
            errorState() {
                return !!this.error;
            }
        },
        methods: {
            clearSignature() {
                this.$refs.signature.clearSignature()
                this.getValue();
            },
            onBegin() {
                this.error = null;
            },
            onEnd() {
                this.getValue().then((value) => {
                    this.$emit('updateValue', value);
                })
            },
            async getValue() {
                const {isEmpty, data} = this.$refs.signature.saveSignature();
                this.data = data;
                
                if (isEmpty) {
                    this.error = 'Signature is mandatory';
                }

                return new Value({
                    value: data,
                    isEmpty: isEmpty,
                    isValid: !isEmpty,
                    error: this.error,
                });
            },
        }
    }
</script>

<style scoped>
	.signature {
		padding: 7px;
		border-radius: 7px 7px 7px 7px;
		-moz-border-radius: 7px 7px 7px 7px;
		-webkit-border-radius: 7px 7px 7px 7px;
		border: 1px solid #006ef5;
	}
	.signature.signature-error {
		border: 2px solid #f50008;
	}
	.signature.signature-success {
		border: 2px solid #00f50a;
	}
</style>